exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.innerHTMLStyle p {\r\n    padding: 0px;\r\n    margin: 0px;\r\n    font-weight: bold;\r\n\r\n}\r\n\r\np {\r\n    font-size: 16px;\r\n    font-family: \"Times New Roman\";\r\n\r\n}\r\n\r\ntbody {\r\n    font-size: 16px;\r\n    font-family: \"Times New Roman\";\r\n\r\n}\r\n\r\n.innerStyle table {\r\n    width: 50% !important;\r\n\r\n}\r\n\r\n.innerStyle p {\r\n    font-size: 13px;\r\n\r\n    font-family: 'Times New Roman';\r\n    margin-bottom: 0px !important;\r\n    margin-top: 10px !important;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/trn-dischargelist/trn-dischargelist.component.css
// module id = ../../../../../src/app/ipd/trn-dischargelist/trn-dischargelist.component.css
// module chunks = main